/**
 * Image du hero : illustration vectorielle créée pour Ermont Live (adoptée par le porteur du projet le 2026-09-22).
 * Une photographie pourra la remplacer ; son crédit, s'il est exigé par la licence, sera alors affiché.
 */
export interface HeroImage {
  readonly src: string;
  /** Sources modernes (AVIF, WebP), du plus efficace au plus compatible. */
  readonly sources?: readonly { readonly type: string; readonly srcSet: string }[];
  readonly srcSet?: string;
  readonly width: number;
  readonly height: number;
  /** Image décorative : texte alternatif vide, le hero porte déjà le titre. */
  readonly alt: string;
  /** Crédit à afficher (photo sous licence) ; absent pour notre propre illustration. */
  readonly credit?: string;
}

export const HERO_IMAGE: HeroImage = {
  src: '/images/ermont/hero-ermont.svg',
  width: 1600,
  height: 640,
  alt: '',
};
